export enum VisitType {
  QuestionnaireOnly = 0,
  Scheduled = 1,
  Instant = 2,
}
